import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Package, Tags, LogOut, ExternalLink, Menu, X } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/i18n/translations";
import { Toaster } from "@/components/ui/sonner";

const NAV = [
  { to: "/admin", end: true, icon: Package, label: "Ürünler" },
  { to: "/admin/categories", icon: Tags, label: "Kategoriler" },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { logout(); navigate("/admin/login", { replace: true }); };

  const SidebarContent = (
    <>
      <div className="flex items-center gap-2 border-b border-zinc-200 px-6 py-5">
        <img src={LOGO_URL} alt="Korva İş Elbiseleri" className="h-8 w-auto object-contain" />
      </div>
      <nav className="flex-1 space-y-1 px-3 py-4">
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            onClick={() => setOpen(false)}
            data-testid={`admin-nav-${n.label}`}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                isActive ? "bg-primary text-white" : "text-zinc-600 hover:bg-zinc-100"
              }`
            }
          >
            <n.icon className="h-4.5 w-4.5" style={{ width: 18, height: 18 }} /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-zinc-200 p-3">
        <a href="/" target="_blank" rel="noreferrer"
          className="mb-1 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-zinc-600 hover:bg-zinc-100">
          <ExternalLink style={{ width: 18, height: 18 }} /> Siteyi Görüntüle
        </a>
        <button
          data-testid="admin-logout"
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-red-600 hover:bg-red-50"
        >
          <LogOut style={{ width: 18, height: 18 }} /> Çıkış Yap
        </button>
      </div>
    </>
  );

  return (
    <div className="flex min-h-screen bg-zinc-50 text-zinc-900">
      {/* Desktop sidebar */}
      <aside className="fixed inset-y-0 start-0 hidden w-64 flex-col border-e border-zinc-200 bg-white lg:flex">
        {SidebarContent}
      </aside>

      {/* Mobile drawer */}
      {open && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <aside className="absolute inset-y-0 start-0 flex w-64 flex-col bg-white">
            <button onClick={() => setOpen(false)} className="absolute end-3 top-4 text-zinc-400"><X className="h-5 w-5" /></button>
            {SidebarContent}
          </aside>
        </div>
      )}

      <div className="flex flex-1 flex-col lg:ms-64">
        <header className="flex items-center justify-between border-b border-zinc-200 bg-white px-5 py-3 lg:hidden">
          <button onClick={() => setOpen(true)} data-testid="admin-menu"><Menu className="h-5 w-5" /></button>
          <img src={LOGO_URL} alt="" className="h-7 w-auto object-contain" />
          <span className="w-5" />
        </header>
        <main className="flex-1 p-5 md:p-8">
          <Outlet />
        </main>
      </div>

      <Toaster position="top-center" />
    </div>
  );
}
